export default {"src":"/_next/static/media/logo.d8adc3b7.svg","height":1500,"width":2000,"blurWidth":0,"blurHeight":0};